var _rect, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 547,
    viewBox: "0 0 1440 547",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 547,
    fill: "#141414"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.001 -5.62624C183.455 3.49288 197.709 28.6145 203.099 56.1479",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M184.031 -15.9983L244.295 24.9052",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-29.3859 425.531C-4.29376 422.499 42.6224 407.935 29.5499 373.928C16.4773 339.921 -9.52376 354.061 -20.8902 365.382C-34.0521 389.708 36.9776 406.903 71.9694 345.33",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1277.92 98.1493C1274.54 73.102 1259.32 26.3945 1225.5 39.9421C1191.68 53.4897 1206.18 79.2902 1217.66 90.497C1242.17 103.317 1258.36 32.0532 1196.31 -2.07264",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1458.25 348.793C1450.04 347.62 1424.53 313.109 1412.79 296C1412.79 311.251 1377.6 331.684 1360 339.995C1376.13 347.327 1412.79 410.386 1412.79 400.12C1412.79 389.855 1468.52 350.26 1458.25 348.793Z",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M478.66 420.949C475.611 409.746 459.99 372.534 451.482 352.834C451.155 352.077 451.834 351.275 452.635 351.467L540.991 372.65C541.939 372.877 542.102 374.286 541.252 374.762C528.601 381.837 496.858 407.615 480.347 421.495C479.762 421.987 478.861 421.686 478.66 420.949Z",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBg);
export default __webpack_public_path__ + "static/media/footer-bg.1216d830f82c4385b8a356b22f337e53.svg";
export { ForwardRef as ReactComponent };